import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPoint } from '@retailer-platform/dashboard/routing'
import { partnerManagementAdminRouter } from './routing/partnerManagementAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'partner-management',
  totem: {
    tool: 'partner-management-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [partnerManagementAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.MarketplaceOps,
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-partner-management-list',
          labelId: 'partnerManagementDomain.listPage.title',
          accessControl: {},
        },
      ],
    },
  ],
}

export default definition
